import { connect } from 'react-redux';
import { compose } from 'redux';
import { setCurrentPtoDialogueOpen } from '../../store/orderDrawer';
import OpenPTOCard from './Card';
import { resetCreatePto } from '../../store/createOrder';

const mapDispatchToProps = {
  resetCreatePto,
  setCurrentPtoDialogueOpen,
};

export default compose(connect(null, mapDispatchToProps))(OpenPTOCard);
